export const environment = {
  production: true,
  apiBaseUrl: 'https://iris.ellipse-online.com/csp/apibna',
  publicBaseUrl: 'https://iris.ellipse-online.com/csp/apibna-public'
};
